"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _grayPercentage = require("gray-percentage");

var _grayPercentage2 = _interopRequireDefault(_grayPercentage);

var _typographyBreakpointConstants = require("typography-breakpoint-constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var theme = {
  title: "Funston",
  baseFontSize: "20px",
  baseLineHeight: 1.4,
  googleFonts: [{
    name: "Patua One",
    styles: ["400"]
  }, {
    name: "Cabin Condensed",
    styles: ["400", "700"]
  }],
  headerFontFamily: ["Patua One", "sans-serif"],
  bodyFontFamily: ["Cabin Condensed", "georgia", "sans-serif"],
  bodyColor: "hsla(0,0%,0%,0.87)",
  headerWeight: "400",
  bodyWeight: 400,
  boldWeight: 700,
  overrideStyles: function overrideStyles(_ref) {
    var scale = _ref.scale,
        rhythm = _ref.rhythm;
    return _defineProperty({
      html: {
        "-webkit-font-smoothing": "antialiased"
      },
      body: {
        letterSpacing: ".03em"
      },
      a: {
        color: "inherit"
      },
      "a:hover": {
        color: "#3498DB"
      },
      blockquote: _extends({}, scale(1 / 5), {
        color: (0, _grayPercentage2.default)(40),
        paddingLeft: rhythm(13 / 16),
        marginLeft: rhythm(-1),
        borderLeft: rhythm(3 / 16) + " solid " + (0, _grayPercentage2.default)(13)
      })
    }, _typographyBreakpointConstants.MOBILE_MEDIA_QUERY, {
      blockquote: {
        marginLeft: rhythm(-3 / 4),
        paddingLeft: rhythm(9 / 16),
        marginRight: 0
      }
    });
  }
};

exports.default = theme;